import { isLegacyUserId } from 'utils/resolveLegacyUserId';

/**
 * The assignee's legacy numeric id. `assigned_user.legacy_id` is resolved
 * server-side by document-service (SP-5743) -- not yet in the published API
 * client's type, so it's read defensively here ahead of that.
 */
export function resolveAssignedUserLegacyId(
  assignedUser: { id: string | number; legacy_id?: string } | null | undefined
): string | undefined {
  if (!assignedUser) return undefined;
  return isLegacyUserId(assignedUser.id) ? String(assignedUser.id) : assignedUser.legacy_id;
}
